/**
 * Rep "My leads" types (S5) — mirrored 1:1 from the backend `com.rep_tasks`
 * entity (apps/api/src/modules/com/entities/rep-task.entity.ts). The list/detail
 * endpoints return the entity enriched server-side with the resolved lead person
 * + company NAMES (out.contact_people / out.companies); the UUID *refs* are kept as
 * secondary references. A name is null when its row is missing — the screens then
 * fall back to the ref honestly and never fabricate a name.
 */

export type RepTaskStatus = 'open' | 'worked' | 'escalated_to_am' | 'closed';
export type RepTaskDisposition = 'meeting_agreed_not_closed' | 'closed' | 'lost';

export interface RepTask {
  id: string;
  workspaceId: string;
  conversationRef: string;
  leadPersonRef: string;
  /** null when the lead's company could not be resolved at handoff time. */
  leadCompanyRef: string | null;
  contextSummary: string;
  assignedRepUserId: string | null;
  taskStatus: RepTaskStatus;
  firstTouchDueAt: string;
  workedAt: string | null;
  disposition: RepTaskDisposition | null;
  version: number;
  createdAt: string;
  updatedAt: string;
  // Resolved server-side from the refs (null when the row is missing).
  personName: string | null;
  personTitle: string | null;
  companyName: string | null;
}

/** The two tabs on the My-leads list: Active = open; History = worked/escalated/closed. */
export type RepTaskTab = 'active' | 'history';

export const ACTIVE_STATUSES: RepTaskStatus[] = ['open'];
export const HISTORY_STATUSES: RepTaskStatus[] = ['worked', 'escalated_to_am', 'closed'];
